import { Inject, Injectable } from '@angular/core';
import { GrowthBook } from '@growthbook/growthbook';
import { BehaviorSubject } from 'rxjs';

export function initializeGrowthBook(growthBookService: GrowthBookService) {
    return () => growthBookService.initialize();
  }

@Injectable({
  providedIn: 'root'
})
export class GrowthBookService {

  private growthbook: GrowthBook;
  private isInitialized = new BehaviorSubject<boolean>(false);

  constructor(
    @Inject('env') private environment : any
  ) {
    this.growthbook = new GrowthBook({
      apiHost: environment.growthbookApiHost,
      clientKey: environment.growthbookClientKey,
      enableDevMode: !environment.production
    });
  }

  async initialize(): Promise<void> {
    try {
      await this.growthbook.init({ streaming: true });
      this.isInitialized.next(true);
    } catch (error) {
      this.isInitialized.next(false);
    }
  }

  isFeatureEnabled(key: string): boolean {
    return this.growthbook.isOn(key);
  }

  getIsInitialized() {
    return this.isInitialized.asObservable();
  }

  setUserAttributes(userId: string, tenantId: string): void {
    this.growthbook.setAttributes({
        "serviceName": this.environment.name,
        "serviceVersion": this.environment.version,
        "id": userId,
        "tenantId": tenantId
    });
  }
}
